import Vue from 'vue';
//TODO need to be removed
// When the request succeeds
const success = (response, context) => {
  context.isSuperCheckinSelected = true;
  context.accountLocks = response.locks;
  if (context.accountLocks.length === 1) {
    context.accountLocks[0].connected = true;
  }
};

// When the request fails
const failed = () => {

};

export default (context, rental_id) => {
  const params = {
    rental_id,
  };

  return Vue.$http.post('/get-super-checkin-locks', params).then((response) => {
    if (response && response.status === 200) {
      success(response.data, context);
    }
  })
    .catch((error) => {
      failed(error,context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/account/getSuperCheckinLocks.js